const DEPRECIATED_ICON_SIZES = {
  xxs: 16,
  xs: 24,
  sm: 48,
  md: 64,
  lg: 72,
  xl: 96,
  xxl: 128,
} as const;

export const ICON_SIZES = {
  small: 16,
  medium: 32,
  large: 48,
  ...DEPRECIATED_ICON_SIZES,
} as const;

export const CARET_WIDTH = 11.5;
export const CARET_HEIGHT = 21.1;
